/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Donor_Thislink1Inputs */

const id_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tautan ini`)
};

const ms_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pautan ini`)
};

const da_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dette link`)
};

const de_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`diesem Link`)
};

const en_us2_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this link`)
};

const es_es2_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`este enlace`)
};

const es_mx2_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`este enlace`)
};

const fil_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`link na ito`)
};

const fr_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ce lien`)
};

const it_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`questo link`)
};

const hu_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erre a linkre`)
};

const nl_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deze link`)
};

const no_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`denne lenken`)
};

const pl_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tego linku`)
};

const pt_br2_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`este link`)
};

const pt_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`este link`)
};

const ro_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`acest link`)
};

const fi_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tähän linkkiin`)
};

const sv_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`denna länk`)
};

const vi_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`liên kết này`)
};

const tr_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bu bağlantı`)
};

const cs_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tento odkaz`)
};

const bg_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`тази връзка`)
};

const ru_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`этой ссылке`)
};

const uk_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`цим посиланням`)
};

const ar_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا الرابط`)
};

const hi_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस लिंक पर`)
};

const th_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลิงก์นี้`)
};

const ja_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このリンク`)
};

const zh_cn2_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此链接`)
};

const zh_hant1_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此連結`)
};

const ko_profile_donor_thislink1 = /** @type {(inputs: Profile_Donor_Thislink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 링크`)
};

/**
* | output |
* | --- |
* | "this link" |
*
* @param {Profile_Donor_Thislink1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_donor_thislink1 = /** @type {((inputs?: Profile_Donor_Thislink1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Donor_Thislink1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_donor_thislink1(inputs)
	if (locale === "ms") return ms_profile_donor_thislink1(inputs)
	if (locale === "da") return da_profile_donor_thislink1(inputs)
	if (locale === "de") return de_profile_donor_thislink1(inputs)
	if (locale === "en-US") return en_us2_profile_donor_thislink1(inputs)
	if (locale === "es-ES") return es_es2_profile_donor_thislink1(inputs)
	if (locale === "es-MX") return es_mx2_profile_donor_thislink1(inputs)
	if (locale === "fil") return fil_profile_donor_thislink1(inputs)
	if (locale === "fr") return fr_profile_donor_thislink1(inputs)
	if (locale === "it") return it_profile_donor_thislink1(inputs)
	if (locale === "hu") return hu_profile_donor_thislink1(inputs)
	if (locale === "nl") return nl_profile_donor_thislink1(inputs)
	if (locale === "no") return no_profile_donor_thislink1(inputs)
	if (locale === "pl") return pl_profile_donor_thislink1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_donor_thislink1(inputs)
	if (locale === "pt") return pt_profile_donor_thislink1(inputs)
	if (locale === "ro") return ro_profile_donor_thislink1(inputs)
	if (locale === "fi") return fi_profile_donor_thislink1(inputs)
	if (locale === "sv") return sv_profile_donor_thislink1(inputs)
	if (locale === "vi") return vi_profile_donor_thislink1(inputs)
	if (locale === "tr") return tr_profile_donor_thislink1(inputs)
	if (locale === "cs") return cs_profile_donor_thislink1(inputs)
	if (locale === "bg") return bg_profile_donor_thislink1(inputs)
	if (locale === "ru") return ru_profile_donor_thislink1(inputs)
	if (locale === "uk") return uk_profile_donor_thislink1(inputs)
	if (locale === "ar") return ar_profile_donor_thislink1(inputs)
	if (locale === "hi") return hi_profile_donor_thislink1(inputs)
	if (locale === "th") return th_profile_donor_thislink1(inputs)
	if (locale === "ja") return ja_profile_donor_thislink1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_donor_thislink1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_donor_thislink1(inputs)
	return ko_profile_donor_thislink1(inputs)
});
export { profile_donor_thislink1 as "profile.donor.thisLink" }